module.exports = __webpack_public_path__ + "static/media/file-png.3d0d2740.svg";